module.exports = __webpack_public_path__ + "static/media/2020.5.15妇联国际家庭日观看直播.4344067f.jpg";